import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  TextInputDefinition,
  TextInputPlatformProps,
} from '../TextInput.types';
import { props as viewerPropsMapper } from './TextInput.mapper';

const props = composeMapper<
  PreviewWrapperProps<TextInputPlatformProps>,
  TextInputDefinition
>()(
  viewerPropsMapper,
  { add: ['shouldResetComponent', 'componentViewMode', 'compPreviewState'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { shouldResetComponent, componentViewMode, compPreviewState } = deps;

    return {
      ...viewerProps,
      previewWrapperProps: {
        shouldResetComponent,
        componentViewMode,
        compPreviewState,
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
